import React, { useEffect } from "react";
import PropTypes from "prop-types";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import Hidden from "@mui/material/Hidden";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { Switch, Route, Link, Redirect, useLocation } from "react-router-dom";
import OrderStatus from "./OrderStatus";
import Sellers from "./sellers/Sellers";
import Contest from "./Contest";
import Ordering from "./ordering/Ordering";
import Products from "./products/Products";
import SalesInvoiceInputMain from "./inputSalesInvoices/SalesInvoiceInputMain";
import SalesInvoiceInputMain_ from "./transactiSellerOrders/SalesInvoiceInputMain";
import ManageInventoryMain from "./manageInventory/ManageInventoryMain";
import MultipleAccountPricings from "./multipleAccountPricings/MultipleAccountPricings";
import Notifications from "./notifications/Notifications";
import Accounts from "./manageAccountAndPricing/Accounts";
import SalesmansMain from "./salesman/SalesmansMain";
import SalesTargets from "./salesTargets/SalesTargets";
import Dashboard from "./dashboard/Dashboard";
import DashboardVersion2 from "./dashboardVersion2/DashboardVersion2";
import SettingsLists from "./settings/SettingsLists";
import TransactiSellerSyncLogs from "./sellerSyncLogs/SellerSyncLogs";
import { useHistory } from "react-router";
import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";
import axios from "axios";
import ForDeliveries from "./forDeliveries/ForDeliveries";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useState } from "react";
const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(0),
  },
}));

function NotificationBell({ count }) {
  return (
    // <IconButton aria-label="notifications">
    <Badge badgeContent={count} color="error">
      <NotificationsIcon />
    </Badge>
    // </IconButton>
  );
}

const objectToFormData = (object) =>
  Object.keys(object).reduce((formData, key) => {
    formData.append(key, object[key]);

    return formData;
  }, new FormData());

function MainDrawer(props) {
  const history = useHistory();
  const location = useLocation();

  const [currentUrl, setCurrentUrl] = useState(window.location.href);

  const [isNeedToChangePassword, setIsNeedToChangePassword] = useState(false);
  const [isCheckPerformed, setIsCheckPerformed] = useState(false);
  const [transactiUserTypeCode, setTransactiUserTypeCode] = useState("");

  const { theProps } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [userInformation, setUserInformation] = React.useState([]);
  const [transactiLabels, setTransactiLabels] = React.useState([]);
  const [newOrders, setNewOrders] = useState(0);
  const [hasActiveNotifications, setHasActiveNotifications] =
    React.useState(true);
  const [navigationBar, setNavigationBar] = React.useState([
    "Dashboard Targets",
    "Input Sales Invoice",
    "Manage Inventory",
    "Create Purchase Order",
    "Orders",
    "For Delivery",
    "Products",
    "Manage Accounts",
    "Multiple Account Pricings",
    "Salesman",
    "Sales Targets",
    "Sellers",
    "Seller Sync Logs",
    "Settings",
    "Notifications",
    "Logout",
  ]);

  const handleDrawerToggle = (e) => {
    e.stopPropagation();
    setMobileOpen(!mobileOpen);
  };

  const itemClick = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    // Update the current URL when the location changes
    setCurrentUrl(window.location.href);
    updateNotificationToRead();
    // checkPasswordPolicySettings()
  }, [location]);

  const onPageChange = () => {
    //checkVersion()
    countSellerNewTransactiSellerOrder();
    checkPasswordPolicySettings();
  };

  useEffect(() => {
    //checkVersion()
    countSellerNewTransactiSellerOrder();
    checkPasswordPolicySettings();
    checkLeadStoreType();
  }, []);

  const updateNotificationToRead = () => {
    const currentPathname = location.pathname;

    try {
      const options = {
        method: "POST",
        url: "/TransactiLiteAndSellerNotifications/updateNotificationsAsRead.json",
        data: objectToFormData({
          currentPathname: currentPathname,
        }),
      };

      axios(options)
        .then((res) => {
          const data = res.data.response;
          const is_success = data.is_success;

          if (is_success) {
            updateNotificationBellBasedOnUrl(currentPathname);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const checkLeadStoreType = () => {
    try {
      const options = {
        method: "POST",
        url: "/TransactiLeadStoreTypeAssignments/fetchTransactiLiteUserTypes.json",
      };

      axios(options)
        .then((res) => {
          if (res.data.response.is_success) {
            setTransactiUserTypeCode(
              res.data.response.lead_store_user_type_code
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const updateNotificationBellBasedOnUrl = (currentPathname) => {
    switch (currentPathname) {
      case "/orders":
        setNewOrders(0);
        break;
    }
  };

  const countSellerNewTransactiSellerOrder = () => {
    try {
      const options = {
        method: "POST",
        url: "/TransactiLiteAndSellerNotifications/countSellerNewTransactiSellerOrder.json",
      };

      axios(options)
        .then((res) => {
          const data = res.data.response;
          const count = data.count;

          if (count > 0) {
            setNewOrders(count);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const checkPasswordPolicySettings = async () => {
    try {
      const options = {
        method: "POST",
        url: "/TransactiLitePasswordPolicySettings/transactiLitePasswordExpiry.json",
      };

      await axios(options)
        .then((res) => {
          const need_to_reset_password = res.data.need_to_reset_password;
          setIsNeedToChangePassword(need_to_reset_password);
          if (need_to_reset_password) {
            history.replace("/settings", { openChangePasswordDialog: true }); // Redirect if password needs to be reset
            setIsCheckPerformed(true);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isCheckPerformed) {
      checkPasswordPolicySettings();
      // history.replace("/settings", { openChangePasswordDialog: true });
      setIsCheckPerformed(false);
    }
  }, [location]);

  const LeadStoreTypeOnehiddenDrawer = [
    "Create Purchase Order",
    "Orders",
    "For Delivery",
    "Multiple Account Pricings",
    "Multiple Sub-Accounts Pricings",
    "Salesman",
    "Sales Targets",
    "Sellers",
    "Seller Sync Logs",
  ];

  const LeadStoreTypeTwohiddenDrawer = [
    "Create Purchase Order",
    "For Delivery",
    "Sales Targets",
    "Sellers",
    "Multiple Sub-Accounts Pricings",
    "Multiple Account Pricings",
  ];

  const LeadStoreTypeThreehiddenDrawer = [
    "Create Purchase Order",
    "For Delivery",
    "Sales Targets",
    "Sellers",
    "Multiple Sub-Accounts Pricings",
    "Multiple Account Pricings",
  ];

  const LeadStoreTypeFourhiddenDrawer = [
    "Create Purchase Order",
    "For Delivery",
    "Multiple Account Pricings",
    "Sales Targets",
    "Sellers",
    "Multiple Sub-Accounts Pricings",
    "Multiple Account Pricings",
  ];

  const showHiddenDrawer = (drawer_name) => {
    let flag = true;

    switch (transactiUserTypeCode) {
      // Lead store without seller ( type 1 )
      case "LSWOS":
        if (LeadStoreTypeOnehiddenDrawer.includes(drawer_name)) {
          flag = false;
        }
        break;

      // Lead store with booking sellers ( type 2 )
      case "LSWBS":
        if (LeadStoreTypeTwohiddenDrawer.includes(drawer_name)) {
          flag = false;
        }
        break;

      // Lead store with van sellers ( type 3 )
      case "LSWVS":
        if (LeadStoreTypeThreehiddenDrawer.includes(drawer_name)) {
          flag = false;
        }
        break;

      // Lead store with both booking and van sellers (type 4)
      case "LSWBAVS":
        if (LeadStoreTypeFourhiddenDrawer.includes(drawer_name)) {
          flag = false;
        }
        break;

      default:
        flag = true;
    }

    return flag;
  };

  const changeNavigationNameBasedOnType = (navigation_name) => {
    let new_nav_name = navigation_name;
    switch (transactiUserTypeCode) {
      case "LSWOS":
      case "LSWBS":
      case "LSWVS":
      case "LSWBAVS":
        if (navigation_name === "Manage Inventory") {
          new_nav_name = "View Sales Invoice Summary";
        } else if (navigation_name === "Orders") {
          new_nav_name = "View Orders";
        } else if (navigation_name === "Products") {
          new_nav_name = "Manage Products";
        } else if (navigation_name === "Salesman") {
          new_nav_name = "Sellers";
        }

        break;
    }

    return new_nav_name;
  };

  const changeNavigationLinkBasedOnType = (
    navigation_link,
    navigation_name
  ) => {
    let new_nav_link = navigation_link;
    switch (transactiUserTypeCode) {
      case "LSWOS":
      case "LSWBS":
      case "LSWVS":
      case "LSWBAVS":
        if (!LeadStoreTypeThreehiddenDrawer.includes(navigation_name)) {
          new_nav_link = "/manageInventory?viewing=view_sales_invoice_summary";
        }
        break;
    }

    return new_nav_link;
  };

  const drawer = (isMobile) => {
    return (
      <div>
        <Toolbar>
          <Typography
            variant="span"
            component="div"
            style={{ textAlign: "center", width: "100%" }}
          >
            <UserInformationsHeader />
          </Typography>
        </Toolbar>
        <Divider />
        <List>
          {navigationBar.map((text, index) => {
            if (
              text === "Dashboard Targets" &&
              showHiddenDrawer("Dashboard Targets")
            ) {
              return (
                <Link
                  to="/dashboard"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    <ListItemText primary={text} />
                  </ListItem>
                </Link>
              );
            } else if (
              text === "Input Sales Invoice" &&
              showHiddenDrawer("Input Sales Invoice")
            ) {
              return (
                <Link
                  to="/inputSalesInvoice"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
                    <ListItemText primary={text} />
                  </ListItem>
                </Link>
              );
            } else if (
              text === "Manage Inventory" &&
              showHiddenDrawer("Manage Inventory")
            ) {
              return (
                <Link
                  to={changeNavigationLinkBasedOnType(
                    "/manageInventory?viewing=options",
                    text
                  )}
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
                    <ListItemText
                      primary={changeNavigationNameBasedOnType(text)}
                    />
                  </ListItem>
                </Link>
              );
            } else if (
              text === "Create Purchase Order" &&
              showHiddenDrawer("Create Purchase Order")
            ) {
              return (
                <Link
                  to="/ordering"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
                    <ListItemText primary={text} />
                  </ListItem>
                </Link>
              );
            } else if (
              text === "For Delivery" &&
              showHiddenDrawer("For Delivery")
            ) {
              return (
                <Link
                  to="/ForDeliveries"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
                    <ListItemText primary={text} />
                  </ListItem>
                </Link>
              );
            } else if (text === "Orders" && showHiddenDrawer("Orders")) {
              return (
                <Link
                  to="/orders"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    <ListItemText
                      primary={changeNavigationNameBasedOnType(text)}
                    />
                    {newOrders != 0 && <NotificationBell count={newOrders} />}
                  </ListItem>
                </Link>
              );
            } else if (text === "Products" && showHiddenDrawer("Products")) {
              return (
                <Link
                  to="/products"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
                    <ListItemText
                      primary={changeNavigationNameBasedOnType(text)}
                    />
                  </ListItem>
                </Link>
              );
            } else if (
              (text === "Manage Accounts" || text === "Manage Sub-Accounts") &&
              (showHiddenDrawer("Manage Accounts") ||
                showHiddenDrawer("Manage Sub-Accounts"))
            ) {
              return (
                <Link
                  to="/manageAccountAndPricing"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
                    <ListItemText primary={text} />
                  </ListItem>
                </Link>
              );
            } else if (
              text === "Multiple Account Pricings" ||
              (text === "Multiple Sub-Accounts Pricings" &&
                showHiddenDrawer("Multiple Account Pricings"))
            ) {
              return (
                <Link
                  to="/multipleAccountPricings"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    <ListItemText primary={text} />
                  </ListItem>
                </Link>
              );
            } else if (text === "Salesman" && showHiddenDrawer("Salesman")) {
              return (
                <Link
                  to="/salesman"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
                    <ListItemText
                      primary={changeNavigationNameBasedOnType(text)}
                    />
                  </ListItem>
                </Link>
              );
            } else if (
              text === "Sales Targets" &&
              showHiddenDrawer("Sales Targets")
            ) {
              return (
                <Link
                  to="/salesTargets"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    <ListItemText primary={text} />
                  </ListItem>
                </Link>
              );
            } else if (
              text === "Seller Sync Logs" &&
              showHiddenDrawer("Seller Sync Logs")
            ) {
              return (
                <Link
                  to="/sellerSyncLogs"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
                    <ListItemText primary={text} />
                  </ListItem>
                </Link>
              );
            } else if (text === "Sellers" && showHiddenDrawer("Sellers")) {
              return (
                <Link
                  to="/sellers"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
                    <ListItemText primary={text} />
                  </ListItem>
                </Link>
              );
            } else if (text === "Settings" && showHiddenDrawer("Settings")) {
              return (
                <Link
                  to="/settings"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
                    <ListItemText primary={text} />
                  </ListItem>
                </Link>
              );
            } else if (
              text === "Notifications" &&
              showHiddenDrawer("Notifications ")
            ) {
              return (
                <Link
                  to="/notifications"
                  key={text}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={onPageChange}
                >
                  <ListItem
                    divider
                    key={text}
                    button
                    onClick={isMobile ? itemClick : () => {}}
                  >
                    {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
                    <ListItemText primary={text} />
                    {hasActiveNotifications && (
                      <NotificationsActiveIcon
                        className={`${classes.largeIcon} ${
                          hasActiveNotifications ? classes.hidden : ""
                        }`}
                        style={{ color: "#F5004F" }}
                      />
                    )}
                  </ListItem>
                </Link>
              );
            } else if (text === "Logout") {
              return (
                <ListItem
                  divider
                  key={text}
                  button
                  onClick={() => {
                    localStorage.clear();
                    history.push("/");
                    window.location.reload();
                  }}
                >
                  {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
                  <ListItemText primary={text} />
                </ListItem>
              );
            }
          })}
        </List>
      </div>
    );
  };

  const container =
    theProps !== undefined ? () => theProps().document.body : undefined;

  useEffect(() => {
    getUserInformation();
  }, []);

  useEffect(() => {
    if (transactiLabels.length != 0) {
      return;
    }

    const getTransactiLiteLabels = async () => {
      try {
        const options = {
          method: "POST",
          url: "/TransactiLabels/getTransactiLiteLabels.json",
        };

        axios(options)
          .then((res) => {
            const labels = res.data.response;

            const modifiedNavBar = [...navigationBar];

            navigationBar.forEach((navigation, index) => {
              if (navigation === "Manage Accounts") {
                modifiedNavBar[index] = "Manage " + labels.accounts.plural;
              } else if (navigation === "Multiple Account Pricings") {
                modifiedNavBar[index] =
                  "Multiple " + labels.accounts.plural + " Pricings";
              }
            });

            setNavigationBar(modifiedNavBar);
            setTransactiLabels(labels);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    };
    getTransactiLiteLabels();
  }, [transactiLabels, navigationBar]);

  useEffect(() => {
    if (!hasActiveNotifications) {
      return;
    }

    const getNotifications = async () => {
      try {
        const options = {
          method: "POST",
          url: "/TransactiNotifications/fetchNotifications.json",
        };

        axios(options)
          .then((res) => {
            console.log();
            const hasNotfi = res.data.response.has_notifications;
            const is_success = res.data.response.is_success;
            if (!is_success) {
              setHasActiveNotifications(false);
            }
            setHasActiveNotifications(hasNotfi);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    };
    getNotifications();
  }, [hasActiveNotifications, navigationBar]);

  useEffect(() => {
    if (Object.keys(userInformation).length === 0) {
      return;
    }
    UserInformationsHeader();
  }, [userInformation]);

  function UserInformationsHeader() {
    if (Object.keys(userInformation).length > 0) {
      return (
        <>
          <small>
            {userInformation.first_name + " " + userInformation.last_name}
          </small>
          <br />
          <small>
            {userInformation.username} ({userInformation.company_id})
          </small>
          <br />
          <small>release : 2025.03.20 12.44.PM</small>
          <br />
        </>
      );
    } else {
      return (
        <>
          <div className={classes.toolbar} />
        </>
      );
    }
  }

  async function getUserInformation() {
    try {
      const options = {
        method: "POST",
        url: "/User/getUserInformation.json",
      };

      const response = await axios(options);
      const user_info = response.data.response.user_info;

      setUserInformation(user_info);
    } catch (error) {
      console.log(error);
    }
  }

  const NotFoundRedirect = () => <Redirect to="/dashboard" />;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer(true)}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer(false)}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {
          <Switch>
            <Route
              path="/dashboard"
              exact
              render={(props) => (
                <DashboardVersion2
                  {...props}
                  handleDrawerToggle={handleDrawerToggle}
                />
              )}
              // render={(props) => <Dashboard {...props} handleDrawerToggle={handleDrawerToggle} />}
            />
            <Route
              path="/sellers"
              exact
              render={(props) => (
                <Sellers {...props} handleDrawerToggle={handleDrawerToggle} />
              )}
            />
            <Route
              path="/Transacti"
              exact
              render={(props) => (
                <Sellers {...props} handleDrawerToggle={handleDrawerToggle} />
              )}
            />
            <Route
              path="/orders"
              exact
              render={(props) => (
                <SalesInvoiceInputMain_
                  {...props}
                  handleDrawerToggle={handleDrawerToggle}
                  transactiUserTypeCode={transactiUserTypeCode}
                />
              )}
            />
            <Route
              path="/inputSalesInvoice"
              exact
              render={(props) => (
                <SalesInvoiceInputMain
                  {...props}
                  handleDrawerToggle={handleDrawerToggle}
                  transactiUserTypeCode={transactiUserTypeCode}
                />
              )}
            />
            <Route
              path="/ordering"
              exact
              render={(props) => (
                <Ordering
                  {...props}
                  handleDrawerToggle={handleDrawerToggle}
                  transactiUserTypeCode={transactiUserTypeCode}
                />
              )}
            />
            <Route
              path="/products"
              exact
              render={(props) => (
                <Products {...props} handleDrawerToggle={handleDrawerToggle} />
              )}
            />
            <Route
              path="/manageAccountAndPricing"
              exact
              render={(props) => (
                <Accounts {...props} handleDrawerToggle={handleDrawerToggle} />
              )}
            />
            <Route
              path="/manageInventory"
              exact
              render={(props) => (
                <ManageInventoryMain
                  {...props}
                  handleDrawerToggle={handleDrawerToggle}
                />
              )}
            />
            <Route
              path="/multipleAccountPricings"
              exact
              render={(props) => (
                <MultipleAccountPricings
                  {...props}
                  handleDrawerToggle={handleDrawerToggle}
                />
              )}
            />
            <Route
              path="/salesman"
              exact
              render={(props) => (
                <SalesmansMain
                  {...props}
                  handleDrawerToggle={handleDrawerToggle}
                />
              )}
            />
            <Route
              path="/salesTargets"
              exact
              render={(props) => (
                <SalesTargets
                  {...props}
                  handleDrawerToggle={handleDrawerToggle}
                />
              )}
            />
            <Route
              path="/settings"
              exact
              render={(props) => (
                <SettingsLists
                  {...props}
                  handleDrawerToggle={handleDrawerToggle}
                  isNeedToChangePassword={isNeedToChangePassword}
                />
              )}
            />
            <Route
              path="/sellerSyncLogs"
              exact
              render={(props) => (
                <TransactiSellerSyncLogs
                  {...props}
                  handleDrawerToggle={handleDrawerToggle}
                />
              )}
            />
            <Route
              path="/notifications"
              exact
              render={(props) => (
                <Notifications
                  {...props}
                  handleDrawerToggle={handleDrawerToggle}
                />
              )}
            />
            <Route
              path="/OrderStatus"
              exact
              render={(props) => <OrderStatus {...props} />}
            />
            <Route
              path="/contest"
              exact
              render={(props) => <Contest {...props} />}
            />
            <Route
              path="/ForDeliveries"
              exact
              render={(props) => (
                <ForDeliveries
                  {...props}
                  handleDrawerToggle={handleDrawerToggle}
                />
              )}
            />
            <Route component={NotFoundRedirect} />
          </Switch>
        }
      </main>
    </div>
  );
}

MainDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default MainDrawer;
